// components/ProtectedRouteByPermission.jsx
import { Navigate } from "react-router-dom";

export default function ProtectedRouteByPermission({ children, permission }) {

  const storedPerms = localStorage.getItem("permissions");
  const storedRoles = localStorage.getItem("roles");

  const permissions = storedPerms ? JSON.parse(storedPerms) : [];
  const roles = storedRoles ? JSON.parse(storedRoles) : [];

  console.log("🔐 Permisos del usuario:", permissions);
  console.log("🎭 Roles del usuario:", roles);
  console.log("🔑 Permiso requerido:", permission);

  // Si es admin, entra a todo
  if (roles.includes("admin")) {
    return children;
  }

  // Si no tiene permisos
  if (!permissions.includes(permission)) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
